/*
 * PERF-024 v2 (perf-fix 18-jun-26): adicionado device_class + connection_type pra segmentar p75/p95 no GA4.
 * Dispara LCP/CLS/INP/TTFB via dataLayer pro GTM/GA4.
 * Zero impacto visual. Carrega defer no theme.liquid.
 */
(function () {
  if (!('PerformanceObserver' in window)) return;

  var vitals = {};
  var DUR_LIMIT = 30000;
  var firedTimeoutId = null;

  function deviceClass() {
    var mem = navigator.deviceMemory || 0;
    var cores = navigator.hardwareConcurrency || 0;
    if (mem > 0 && mem <= 2) return 'low-end';
    if (cores > 0 && cores <= 4) return 'low-end';
    if (mem >= 8 || cores >= 8) return 'high-end';
    return 'mid-range';
  }

  function connectionType() {
    try {
      var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      return c ? (c.effectiveType || 'unknown') : 'unknown';
    } catch (e) { return 'unknown'; }
  }

  function tryReport(reason) {
    if (window.__webVitalsReported) return;
    window.__webVitalsReported = true;
    if (firedTimeoutId) clearTimeout(firedTimeoutId);

    var loadTiming = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || performance.timing;
    var ttfb = loadTiming.responseStart ? Math.round(loadTiming.responseStart - (loadTiming.requestStart || 0)) : null;
    var domReady = loadTiming.domContentLoadedEventEnd ? Math.round(loadTiming.domContentLoadedEventEnd - (loadTiming.startTime || 0)) : null;
    var load = loadTiming.loadEventEnd ? Math.round(loadTiming.loadEventEnd - (loadTiming.startTime || 0)) : null;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'web_vitals',
      web_vitals_reason: reason,
      web_vitals_lcp: vitals.lcp || null,
      web_vitals_cls: vitals.cls || null,
      web_vitals_inp: vitals.inp || null,
      web_vitals_ttfb: ttfb,
      web_vitals_dom_ready: domReady,
      web_vitals_load: load,
      web_vitals_page_path: window.location.pathname,
      web_vitals_device_class: deviceClass(),
      web_vitals_connection: connectionType()
    });
  }

  try {
    new PerformanceObserver(function (list) {
      var entries = list.getEntries();
      var last = entries[entries.length - 1];
      if (last) vitals.lcp = Math.round(last.renderTime || last.loadTime || last.startTime);
    }).observe({ type: 'largest-contentful-paint', buffered: true });
  } catch (e) {}

  try {
    var clsValue = 0;
    new PerformanceObserver(function (list) {
      list.getEntries().forEach(function (entry) {
        if (!entry.hadRecentInput) clsValue += entry.value;
      });
      vitals.cls = Math.round(clsValue * 10000) / 10000;
    }).observe({ type: 'layout-shift', buffered: true });
  } catch (e) {}

  try {
    new PerformanceObserver(function (list) {
      list.getEntries().forEach(function (entry) {
        var dur = Math.round(entry.duration || (entry.processingEnd - entry.startTime));
        if (!vitals.inp || dur > vitals.inp) vitals.inp = dur;
      });
    }).observe({ type: 'event', durationThreshold: 16, buffered: true });
  } catch (e) {}

  window.addEventListener('pagehide', function () { tryReport('pagehide'); }, { once: true });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') tryReport('visibility_hidden');
  });
  firedTimeoutId = setTimeout(function () { tryReport('timeout_30s'); }, DUR_LIMIT);
})();
